import React from 'react'
import * as styles from './styles.module.scss'
import { withPrefix } from 'gatsby'

// /**
//  */
// const Container = () => {
//   return <div className={styles.Container}></div>
// }

/**
 */
export const Logo = ({ className }) => {
  return (
    <div
      className={className ?? styles.Logo}
      style={{
        backgroundImage: `url(${withPrefix('/images/layout/icon_logo.png')})`,
      }}
    />
  )
}

/**
 */
export const Content = ({ className }) => {
  return <Logo className={className} />
}
